export default "__VITE_ASSET__af6231e8__"